const version = require('../version.json');

const currentVersion = version.currentVersion;

module.exports = currentVersion;
